import {
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    makeStyles,
    IconButton,
} from "@material-ui/core";
import {
    Add,
    Edit,
    Delete,
} from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { showAddItemCategoriesDialog } from "../item-categories-add/item-categories-add-slice"
import { useEffect } from "react";
import { db } from "../../../../firebase";
import { showEditItemCategoriesDialog } from "../item-categories-edit/item-categories-edit-slice";
import { showDeleteItemCategoriesDialog } from "../item-categories-delete/item-categories-delete-slice";
import { getItemCategoriesService } from "./item-categories-list-service";
import ItemCategoriesListLoading from "./item-categories-list-loading";
import ItemCategoriesListEmpty from "./item-categories-list-empty";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    tableHeader: {
        background: "#111111",
        height: "100%",
        color: "#fbbbd3",
        fontSize: 14,
    },
    button: {
        background: "#111111",
        color: "#fbbbd3",
        justifyContent: "right",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
        color: "#111111",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    title: {
        color:"#111111",
        marginBottom: 20,
    }
}));


const ItemCategoriesList = () => {
    const classes = useStyles();
    const itemCategoriesCollection = useSelector((state) => state.itemCategoriesListSlice.rows);
    const isLoading = useSelector((state) => state.itemCategoriesListSlice.isLoading);
    const dispatch = useDispatch();

    // get data
    useEffect(() => {
        const fetchData = async () => {
            try {
                await getItemCategoriesService(dispatch, db, "item_categories");
            } catch(e) {
                dispatch(showErrorSnackbar("Something went wrong while trying to fetch."));
                console.error("ItemCategoriesList fetchData error: ", e);
            }
        };
        fetchData();
    }, [dispatch]);

    // open add dialog
    const handleAddOpen = () => {
        dispatch(showAddItemCategoriesDialog());
    };

    // open edit dialog
    const handleEditOpen = (row) => {
        dispatch(showEditItemCategoriesDialog(row));
    };

    // open delete dialog
    const handleDeleteOpen = (row) => {
        dispatch(showDeleteItemCategoriesDialog(row));
    };

    // return loading state if isLoading is true
    if (isLoading) {
        return <ItemCategoriesListLoading/>
    }

    // return empty state if isLoading is false and itemCategoriesCollection has no collection
    if (!isLoading && itemCategoriesCollection.length === 0) {
        return <ItemCategoriesListEmpty/>
    }

    return (
        <>
            <Typography className={classes.title} variant="h4">Item Categories</Typography>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 10}}>
                <Button
                    variant="contained"
                    className={classes.button}
                    startIcon={<Add/>}
                    onClick={handleAddOpen}
                >
                    Add
                </Button>
            </div>
            
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left" className={classes.tableHeader}>Code</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Name</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Description</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {itemCategoriesCollection.map((row) => (
                            <TableRow key={row.code}>
                                <TableCell component="th" scope="row">
                                    {row.code}
                                </TableCell>
                                <TableCell align="right">{row.name}</TableCell>
                                <TableCell align="right">{row.description}</TableCell>
                                <TableCell align="center">
                                    <IconButton
                                        className={classes.buttonText}
                                        onClick={() => handleEditOpen(row)}
                                    >
                                        <Edit/>
                                    </IconButton>
                                    <IconButton
                                        className={classes.buttonText}
                                        onClick={() => handleDeleteOpen(row)}
                                    >
                                        <Delete/>
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default ItemCategoriesList;